<span *ngIf="battery.getBatteryCase() === BatteryCase.BATTERY_VOLT_MILLI"
  >{{ battery.getBatteryVoltMilli() / 1e3 | number: "1.1" }}V</span
>
<span *ngIf="battery.getBatteryCase() === BatteryCase.BATTERY_SOC_PERCENT"
  >{{ battery.getBatterySocPercent() }}%</span
>
